// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__1qJfR","description":"MealItem_description__16gvn","price":"MealItem_price__2XgaT"};